(function() {
  'use strict';
  
  // Prevent multiple initializations
  if (window.bppInitialized) {
    console.log('[BPP] Already initialized, skipping');
    return;
  }
  window.bppInitialized = true;
  
  if (!window.bppSettings || !window.Shopify) { return; }
  const settings = window.bppSettings;
  const shopifyData = window.Shopify;

  // Test localStorage availability
  const testLocalStorage = () => {
    try {
      const test = '__bpp_test__';
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch(e) {
      console.error('[BPP] localStorage not available:', e);
      return false;
    }
  };

  if (!testLocalStorage()) {
    console.error('[BPP] Cannot use localStorage - popup will show on every page');
    return;
  }

  // --- FULL EXCLUSION LOGIC ---
  // 1. Check for the theme's 'facepad' pop-up condition
  let isFacepadPage = false;
  if (shopifyData.template === 'product' && shopifyData.product && Array.isArray(shopifyData.product.tags)) {
    isFacepadPage = shopifyData.product.tags.includes('facepad');
  }

  // 2. Check the user-defined exclusion list from Theme Settings
  let isManuallyExcluded = false;
  if (settings.excludedUrls && Array.isArray(settings.excludedUrls)) {
    isManuallyExcluded = settings.excludedUrls.some(path => {
      const trimmedPath = path.trim();
      return trimmedPath && shopifyData.request_path.includes(trimmedPath);
    });
  }

  // 3. Stop script if any exclusion is met
  if (isFacepadPage || isManuallyExcluded) {
    console.log('[BPP] Page is excluded. Pop-up will not run.');
    return;
  }
  
  // 4. Check if the real form exists (final check)
  const formSource = document.getElementById('bpp-form-source');
  if (!formSource) { 
    console.log('[BPP] Form source not found');
    return; 
  }
  // --- END OF EXCLUSION LOGIC ---

  // Use both localStorage and sessionStorage for redundancy
  const STORAGE_KEY = 'bpp_last_shown';
  const SESSION_KEY = 'bpp_session_shown';

  const shouldShowPopup = () => {
    // Check session first (prevents showing multiple times in same session)
    const shownThisSession = sessionStorage.getItem(SESSION_KEY);
    if (shownThisSession && !settings.isTestMode) {
      console.log('[BPP] Already shown this session');
      return false;
    }

    if (settings.isTestMode) { 
      console.log('[BPP] Test mode enabled - showing popup');
      return true; 
    }
    
    const lastShown = localStorage.getItem(STORAGE_KEY);
    const currentTime = new Date().getTime();
    
    if (!lastShown) { 
      console.log('[BPP] No previous showing recorded - will show popup');
      return true; 
    }
    
    const lastShownTime = new Date(lastShown).getTime();
    const hoursSinceShown = (currentTime - lastShownTime) / (1000 * 60 * 60);
    const daysSinceShown = hoursSinceShown / 24;
    const shouldShow = daysSinceShown >= settings.cookieDurationDays;
    
    console.log(`[BPP] Debug info:
      Last shown: ${lastShown}
      Current time: ${new Date().toISOString()}
      Hours since: ${hoursSinceShown.toFixed(2)}
      Days since: ${daysSinceShown.toFixed(2)}
      Required days: ${settings.cookieDurationDays}
      Will show: ${shouldShow}`);
    
    return shouldShow;
  };

  const markPopupAsShown = () => {
    const timestamp = new Date().toISOString();
    try {
      localStorage.setItem(STORAGE_KEY, timestamp);
      sessionStorage.setItem(SESSION_KEY, 'true');
      console.log('[BPP] Marked popup as shown at:', timestamp);
      
      // Verify it was saved
      const saved = localStorage.getItem(STORAGE_KEY);
      console.log('[BPP] Verification - saved timestamp:', saved);
    } catch(e) {
      console.error('[BPP] Failed to save timestamp:', e);
    }
  };

  const createPopup = () => {
    // Prevent duplicate popups
    if (document.getElementById('bulletproof-popup')) {
      console.log('[BPP] Popup already exists');
      return;
    }

    const hasImage = settings.imageUrl;
    const popupHTML = `
      <div class="bpp-overlay"></div>
      <div class="bpp-container ${hasImage ? 'has-image' : ''}">
        ${hasImage ? `<div class="bpp-image-wrapper"><img src="${settings.imageUrl}" alt="Newsletter signup image"></div>` : ''}
        <div class="bpp-content">
          <button type="button" class="bpp-close-btn" aria-label="Close pop-up">×</button>
          <div class="bpp-body">
             <div class="bpp-text">${settings.text}</div>
             <div id="bpp-form-target"></div>
             <div class="bpp-error-message" style="display: none; color: red; margin-top: 10px;"></div>
             <div class="bpp-footer-text">${settings.footerText}</div>
          </div>
        </div>
      </div>
      <iframe name="bpp-hidden-iframe" id="bpp-hidden-iframe" style="display: none;"></iframe>
    `;
    const popupWrapper = document.createElement('div');
    popupWrapper.id = 'bulletproof-popup';
    popupWrapper.className = 'bpp-wrapper';
    popupWrapper.style.display = 'none';
    popupWrapper.innerHTML = popupHTML;

    const realForm = formSource.querySelector('form');
    const formTarget = popupWrapper.querySelector('#bpp-form-target');
    if (realForm && formTarget) {
      // Set form target to hidden iframe to prevent page redirect
      realForm.setAttribute('target', 'bpp-hidden-iframe');
      formTarget.appendChild(realForm);
    }
    
    document.body.appendChild(popupWrapper);
    popupWrapper.style.display = 'flex';
    
    // Mark popup as shown immediately when it appears (not in test mode)
    if (!settings.isTestMode) {
      markPopupAsShown();
    }
    
    attachListeners(popupWrapper, realForm);
  };
  
  const showSuccessState = (popupBody) => {
    popupBody.innerHTML = `
      <h2 class="bpp-success-headline">${settings.successHeadline}</h2>
      <p class="bpp-success-text">Your discount code is:</p>
      <div class="bpp-coupon-box">
        <span id="bpp-discount-code">${settings.successCode}</span>
        <button type="button" id="bpp-copy-button" class="bpp-copy-button">Copy</button>
      </div>
    `;
    const copyButton = popupBody.querySelector('#bpp-copy-button');
    copyButton.addEventListener('click', () => {
      navigator.clipboard.writeText(settings.successCode).then(() => {
        copyButton.textContent = 'Copied!';
        setTimeout(() => { copyButton.textContent = 'Copy'; }, 2000);
      });
    });
  };

  const showError = (popupWrapper, message) => {
    const errorDiv = popupWrapper.querySelector('.bpp-error-message');
    if (errorDiv) {
      errorDiv.textContent = message;
      errorDiv.style.display = 'block';
    }
  };

  const attachListeners = (popupWrapper, form) => {
    if (!form) return;
    const closeBtn = popupWrapper.querySelector('.bpp-close-btn');
    const overlay = popupWrapper.querySelector('.bpp-overlay');
    
    const hidePopup = () => { 
      popupWrapper.style.display = 'none';
      // Ensure the timestamp is set when closing
      if (!settings.isTestMode) {
        markPopupAsShown();
      }
    };
    
    closeBtn.addEventListener('click', hidePopup);
    overlay.addEventListener('click', hidePopup);

    form.addEventListener('submit', function(event) {
      // Don't prevent default - let the form submit to the iframe
      const submitButton = form.querySelector('.bpp-button');
      const originalButtonText = submitButton.textContent;
      const errorDiv = popupWrapper.querySelector('.bpp-error-message');
      const emailInput = form.querySelector('input[type="email"]');
      
      // Reset error message
      if (errorDiv) {
        errorDiv.style.display = 'none';
      }
      
      // Validate email
      if (!emailInput.value || !emailInput.validity.valid) {
        event.preventDefault();
        showError(popupWrapper, 'Please enter a valid email address.');
        return;
      }
      
      submitButton.textContent = 'Subscribing...';
      submitButton.disabled = true;

      // Set up iframe load listener
      const iframe = document.getElementById('bpp-hidden-iframe');
      let responseHandled = false;
      
      const handleResponse = () => {
        if (responseHandled) return;
        responseHandled = true;
        
        // Always show success after a delay since customer IS being added
        setTimeout(() => {
          // Update the timestamp when form is successfully submitted
          if (!settings.isTestMode) {
            markPopupAsShown();
          }
          showSuccessState(popupWrapper.querySelector('.bpp-body'));
        }, 1500);
      };
      
      // Listen for iframe load (form submission complete)
      iframe.addEventListener('load', handleResponse);
      
      // Backup timeout in case iframe doesn't trigger load event
      setTimeout(handleResponse, 3000);
    });
  };

  // Only create popup if it should be shown
  const shouldShow = shouldShowPopup();
  console.log('[BPP] Final decision - should show popup:', shouldShow);
  
  if (shouldShow) {
    const displayDelay = settings.isTestMode ? 3000 : (settings.delay * 1000);
    console.log('[BPP] Will show popup in', displayDelay, 'ms');
    setTimeout(createPopup, displayDelay);
  }
})();